import { ThemeOptions } from '@mui/material';
import { colors } from '@sensei/pi-component';

export const MuiTab = (theme: ThemeOptions) => {
    return {
        styleOverrides: {
            root: {
                ...(theme?.components?.MuiTab?.styleOverrides?.root as object),
                '&.Mui-selected': {
                    color: colors.CARBON,
                },
            },
            textColorPrimary: {
                color: colors.CARBON,
            },
        },
    };
};
